import { Component, inject } from '@angular/core';
import { map } from 'rxjs';
import { AdminDashboardService } from './admin-dashboard.service';
import { IAdminDashboard } from '../../core/types/admin-dashboard.interface';
import { AsyncPipe } from '@angular/common';
import { SharedModule } from '../../core/shared.module';
import { AuthService } from '../../core/auth/auth.service';

interface DashboardRoute {
  name: string;
  path: string;
  data?: keyof IAdminDashboard;
  icon?: string;
  queryParams?: Record<string, string | number>;
}

function buildRoutes(isSuperAdmin: boolean): DashboardRoute[] {
  return [
    {
      name: 'Resellers',
      path: '/admin/resellers',
      icon: 'assets/icons/navigation.svg#customers',
      data: 'resellers',
    },
    {
      name: 'Users',
      path: '/admin/users',
      icon: 'assets/icons/navigation.svg#users',
      data: 'users',
    },
    {
      name: 'Projects',
      path: '/admin/projects',
      icon: 'assets/icons/navigation.svg#projects',
      data: 'projects',
    },
    {
      name: 'Open Reseller Requests',
      path: '/admin/projects',
      icon: 'assets/icons/navigation.svg#projects',
      data: 'open_reseller_requests',
      queryParams: {
        search: 'special pricing requested',
        page: 1,
      },
    },
    ...(isSuperAdmin
      ? [
          {
            name: 'Manufacturers',
            path: '/admin/manufacturers',
            icon: 'assets/icons/navigation.svg#stack',
            data: 'manufacturers' as const,
          },
        ]
      : []),
    {
      name: 'Battery Models',
      path: '/admin/batteries',
      icon: 'assets/icons/navigation.svg#battery',
      data: 'batteries',
    },
    {
      name: 'Part Numbers',
      path: '/admin/part-numbers',
      icon: 'assets/icons/navigation.svg#battery',
      data: undefined,
    },
  ];
}

@Component({
  selector: 'admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
  imports: [
    SharedModule,
    AsyncPipe,
  ],
})
export class AdminDashboardComponent {
  private readonly adminDashboardService = inject(AdminDashboardService);
  private readonly authService = inject(AuthService);

  readonly data$ = this.adminDashboardService.findAll();
  readonly routes$ = this.authService.isSuperAdmin$.pipe(
    map((isSuperAdmin) => buildRoutes(isSuperAdmin)),
  );

  getCardItems(data: IAdminDashboard, key: keyof IAdminDashboard): string[] {
    const value = (data as Partial<IAdminDashboard>)[key];
    return Array.isArray(value) ? value : [];
  }
}
